import { entity } from '../../region.json';
import isStaging from '../../utils/isStaging';

export const NETHERLANDS = {
  externalFormCTALink:
    'https://www.parkncharge.nl/laden-in-je-buurt/openbare-laadpaal-aanvragen/?_gl=1*1qcdwym*_up*MQ..&gclid=CjwKCAjwmaO4BhAhEiwA5p4YL9y2r364Dw0bJExPXrjEVkkHh1kSm-TENxmK3Rw8pjvWWGPvK_MvkhoCTFsQAvD_BwE',
};

export default function matchEntities(entities) {
  return entities.some(currentEntity => currentEntity === entity);
}

export function noSocialMedia() {
  return !matchEntities(['SPAIN', 'POLAND']);
}
export function shouldShowBusinessNumber() {
  return !matchEntities(['SPAIN', 'POLAND', 'NETHERLANDS']);
}
export function filterLinksByEntity(link) {
  return !link?.hide;
}
export function shouldShowAppStoreLinks() {
  return true;
}
export function shouldShowExternalFormCTA() {
  return matchEntities(['NETHERLANDS']);
}
export function getLinkBlocks(linksByBlock, locale) {
  return linksByBlock.map(block => {
    const bl = block.links.filter(filterLinksByEntity).map(link => ({
      ref: link.isExternal ? link.ref : `/${locale}${link.ref}`,
      text: link.text,
      isExternal: link.isExternal,
    }));
    return { name: block.name, links: bl };
  });
}
export function allowPopup() {
  return !matchEntities(['FRANCE', 'SPAIN', 'POLAND']);
}
export const ALL_ENTITES = [
  'GERMANY',
  'SWEDEN',
  'FRANCE',
  'SPAIN',
  'UK',
  'POLAND',
];

export const topLevelDomains = {
  GERMANY: 'eu',
  SWEDEN: 'se',
  FRANCE: 'fr',
  SPAIN: 'es',
  UK: 'uk',
  POLAND: 'pl',
  NETHERLANDS: 'nl',
};

export const newsTagId = {
  GERMANY: 40,
  SWEDEN: 41,
  FRANCE: 42,
  SPAIN: 45,
  UK: 39,
  POLAND: 44,
  NETHERLANDS: 43,
};

export const SUPPORTED_LANGS = ['de', 'sv', 'fr'];

export const LANGS_TO_ENTITIES = {
  de: 'GERMANY',
  sv: 'SWEDEN',
  fr: 'FRANCE',
  es: 'SPAIN',
  ...(isStaging && { en: 'UK' }),
};

export function specialCaseSpain(websiteEntity, lang) {
  if (websiteEntity === 'GERMANY' && lang === 'es') {
    return true;
  }
  return false;
}

export const SHOW_NON_QWELLO_POLES = matchEntities(['POLAND', 'NETHERLANDS']);

function redirectToNetherlandsExternalForm(to) {
  if (to.path === '/aanvraag') {
    window.location.href = NETHERLANDS.googleFromCTALink;
    return true;
  }
  return false;
}
const disabledLinks = ['FAQ', 'Register'];
// For now we only have 1 route on the Netherlands website = "tarief"
// except for one route = "aanvraag"
// which redirects to a google form
export function OnlyRunIfNetherlandsEntity(to, next) {
  // if not netherlands then simply ignore;
  if (matchEntities(['NETHERLANDS'])) {
    if (redirectToNetherlandsExternalForm(to)) {
      return true;
    }
    if (disabledLinks.includes(to.name)) {
      next('/');
      return true;
    }
  }
  return false;
}
